/*=========================================================================================
  File Name: moduleVariablesMutations.js
  Description: Variables Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    ADD_ITEM(state, item) {
        state.products.unshift(item)
    },

    SET_SYMPTOMS(state, symptoms) {
        // state.symptoms = symptoms;
        state.symptoms = [];
        state.default_symptoms = [];
        state.all_symptoms = [];

        for (let i = 0; i <symptoms.length; i++) {
            let symptom = {
                id: symptoms[i].id,
                georgian: symptoms[i].translations[0].title,
                english: symptoms[i].translations[1].title,
                isSingular: symptoms[i].isSingular,
                default: false,
                translations: symptoms[i].translations
            };
            state.all_symptoms.push({
                value: symptoms[i].id,
                text: symptoms[i].translations[0].title
            })
            if(symptoms[i].default) {
                symptom["_rowVariant"] = "secondary";
                state.default_symptoms.push(symptom)
            }
            else {state.symptoms.push(symptom);}
        }
    },

    SET_RISK_FACTORS(state, risk_factors) {
        // state.risk_factors = [];
        //
        // for (let i = 0; i <risk_factors.length; i++) {
        //     let risk_factor = {
        //         id: risk_factors[i].id,
        //         georgian: risk_factors[i].translations[0].title,
        //         english: risk_factors[i].translations[1].title,
        //         translations: risk_factors[i].translations
        //     };
        //     state.risk_factors.push(risk_factor);
        // }

        state.risk_factors = [];
        state.default_risk_factors = [];
        state.all_risk_factors = [];

        for (let i = 0; i <risk_factors.length; i++) {
            let symptom = {
                id: risk_factors[i].id,
                georgian: risk_factors[i].translations[0].title,
                english: risk_factors[i].translations[1].title,
                isSingular: risk_factors[i].isSingular,
                default: false,
                translations: risk_factors[i].translations
            };
            state.all_risk_factors.push({
                value: risk_factors[i].id,
                text: risk_factors[i].translations[0].title
            })

            if(risk_factors[i].default) {
                symptom["_rowVariant"] = "secondary";
                state.default_risk_factors.push(symptom)
            }
            else {state.risk_factors.push(symptom);}
        }
    },

    SET_TBI_LOCALIZATIONS(state, tbi_localization) {
        //
        // state.tbi_localization = [];
        //
        // for (let i = 0; i <tbi_localization.length; i++) {
        //     let item = {
        //         id: tbi_localization[i].id,
        //         georgian: tbi_localization[i].translations[0].title,
        //         english: tbi_localization[i].translations[1].title,
        //         translations: tbi_localization[i].translations
        //
        //     };
        //     state.tbi_localization.push(item);
        // }


        state.tbi_localization = [];
        state.default_tbi_localization = [];

        for (let i = 0; i <tbi_localization.length; i++) {
            let symptom = {
                id: tbi_localization[i].id,
                georgian: tbi_localization[i].translations[0].title,
                english: tbi_localization[i].translations[1].title,
                isSingular: tbi_localization[i].isSingular,
                default: false,
                translations: tbi_localization[i].translations
            };

            if(tbi_localization[i].default) {
                symptom["_rowVariant"] = "secondary";
                state.default_tbi_localization.push(symptom)
            }
            else {state.tbi_localization.push(symptom);}
        }
    },

    SET_SIDE_EFFECTS(state, side_effects) {
        // state.symptoms = symptoms;
        state.side_effects = [];
        state.default_side_effects = [];

        for (let i = 0; i <side_effects.length; i++) {
            let side_effect = {
                id: side_effects[i].id,
                georgian: side_effects[i].translations[0].title,
                english: side_effects[i].translations[1].title,
                isSingular: side_effects[i].isSingular,
                default: false,
                translations: side_effects[i].translations
            };

            if(side_effects[i].default) {
                side_effect["_rowVariant"] = "secondary";
                state.default_side_effects.push(side_effect)
            }
            else {state.side_effects.push(side_effect);}
        }
    },

    SET_LABORATORY_MONITORING(state, monitoring) {
        // state.symptoms = symptoms;
        state.laboratory_monitoring = [];
        state.default_laboratory_monitoring = [];

        for (let i = 0; i <monitoring.length; i++) {
            let variable = {
                id: monitoring[i].id,
                georgian: monitoring[i].translations[0].title,
                english: monitoring[i].translations[1].title,
                isSingular: monitoring[i].isSingular,
                default: false,
                translations: monitoring[i].translations
            };

            if(monitoring[i].default) {
                variable["_rowVariant"] = "secondary";
                state.default_laboratory_monitoring.push(variable)
            }
            else {state.laboratory_monitoring.push(variable);}
        }
        console.log("monitoring", state.laboratory_monitoring)

    },

}
